import { haveValue } from "../../../helper/common";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import { useNavigate } from "react-router-dom";

const GuarantorsModel = ({
  user,
  profileId,
  openModal,
  closeModel,
  guarantorsList,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  return (
    <>
      <Modal
        show={openModal}
        onHide={closeModel}
        centered
        className="newmodalui asguarantor share-profile"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {_t(
              "selectLLWithWhomYouWantToShareTheProfileGuarantorSide",
              "In Modal when Parent LL is going to share a tenant profile with a Sub LL"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="creat-guarantor-modal-inner">
            {haveValue(guarantorsList) &&
            Array.isArray(guarantorsList) &&
            guarantorsList.length > 0 ? (
              <ul>
                {guarantorsList.map((guarantor) => (
                  <li className="share-it">
                    {guarantor?.fname} {guarantor?.lname}
                    <button
                      className=""
                      onClick={() => {
                        user?.isParentLL
                          ? navigate(
                              `/profile-property?agencylink=${profileId}&guarantor=${guarantor?._id}`
                            )
                          : navigate(
                              `/profile-property?sharedprofileid=${profileId}&guarantor=${guarantor?._id}`
                            );
                      }}
                    >
                      {_t("viewProfile")}
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-center">{_t("noGuarantorsFound")}</p>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GuarantorsModel;
